<form class="pt-4 pb-2 px-spacer-responsive bg-white">
  <h6 data-testId="comment-title">{{canEdit ? editCommentLabel : commentLabel}}</h6>
  <mat-form-field appearance="fill" class="w-100">
    <textarea
      matInput
      [maxlength]="maxLength"
      cdkTextareaAutosize
      cdkAutosizeMinRows="2"
      cdkAutosizeMaxRows="5"
      [formControl]="commentFormControl"
      data-testId="edit-comment"
    ></textarea>
  </mat-form-field>
</form>
